define(['jquery'], function ($) {
    "use strict";
    return {
        create: function ($sliderContainer) {
            let self = this;
            let $sliderElements = $sliderContainer.find('.slider-element-storage .slider-element');
            let counter = 1;
            let countSliderElements = $sliderElements.length;
            let $sliderContentArea = $sliderContainer.find('.slider-content-area');
            $sliderElements.each(function () {
                let $job = $(this).find('.subheader');
                let $personName = $(this).find('.header');
                let $quote = $(this).find('.bodytext');
                let $image = $(this).find('.image');
                if (counter === 1) {
                    $job.addClass('active');
                    $personName.addClass('active');
                    $quote.addClass('active');
                    $image.addClass('active');
                } else if (counter === 2) {
                    $job.addClass('next');
                    $personName.addClass('next');
                    $quote.addClass('next');
                    $image.addClass('next');
                } else if (counter === countSliderElements) {
                    $job.addClass('prev');
                    $personName.addClass('prev');
                    $quote.addClass('prev');
                    $image.addClass('prev');
                } else {
                    $image.css('left', '-100%');
                }
                $sliderContentArea.find('.job').append($job);
                $sliderContentArea.find('.person-name').append($personName);
                $sliderContentArea.find('.quote').append($quote);
                $sliderContentArea.find('div.image').append($image);
                counter++;
            });

            $sliderContentArea.find('div.image').height($sliderContentArea.find('figure.image.active').height());
            $sliderContentArea.find('figure.image.prev').css('left', '-100%');
            $sliderContentArea.find('figure.image.next').css('left', '100%');

            let $prevButton = $sliderContainer.find('.slider-button-prev');
            let $nextButton = $sliderContainer.find('.slider-button-next');

            $prevButton.on('click',function() {
                self.slideAction($sliderContainer, 'prev');
            });
            $nextButton.on('click',function() {
                self.slideAction($sliderContainer, 'next');
            });

            $('.half-background').height($sliderContainer.height());
            self.updateNextAndPrevButtons($sliderContainer);
        },
        updateNextAndPrevButtons: function($sliderContainer) {
            let $sliderActivePerson = $sliderContainer.find('.slider-content-area .person-name .active');
            let $prevButton = $sliderContainer.find('.slider-button-prev');
            let $nextButton = $sliderContainer.find('.slider-button-next');

            let $nextPerson = $sliderActivePerson.next();
            if ($nextPerson.length === 0) {
                $nextPerson = $sliderActivePerson.siblings().first();
            }

            let $prevPerson = $sliderActivePerson.prev();
            if ($prevPerson.length === 0) {
                $prevPerson = $sliderActivePerson.siblings().last();
            }

            $nextButton.text($nextPerson.text());
            $prevButton.text($prevPerson.text());
        },
        slideAction: function($sliderContainer, slideDirection) {
            let self = this;
            let slidableElements = ['.job', '.person-name', '.quote', 'div.image'];

            $.each(slidableElements, function(key, currentElement) {
                if (currentElement === 'div.image') {
                    let $activeElement = $(currentElement).find('.active');
                    let $targetElement;
                    if (slideDirection === 'prev') {
                        $targetElement = $activeElement.siblings('.prev');
                        $activeElement.stop().animate({
                            left: "20%"
                        }, 500, function () {
                            $activeElement.css('left', '100%');
                        });
                    } else {
                        $targetElement = $activeElement.siblings('.next');
                        $activeElement.stop().animate({
                            left: "-20%"
                        }, 500, function () {
                            $activeElement.css('left', '-100%');
                        });
                    }

                    $activeElement.removeClass('active');
                    $activeElement.siblings('.next').removeClass('next');
                    $activeElement.siblings('.prev').removeClass('prev');

                    $targetElement.addClass('active');

                    let $newPrevElement, $newNextElement;
                    $newPrevElement = $targetElement.prev();
                    if ($newPrevElement.length === 0) {
                        $newPrevElement = $targetElement.siblings().last();
                    }
                    $newPrevElement.addClass('prev');

                    $newNextElement = $targetElement.next();
                    if ($newNextElement.length === 0) {
                        $newNextElement = $targetElement.siblings().first();
                    }
                    $newNextElement.addClass('next');

                    $targetElement.stop().animate({
                        left: "0"
                    }, 500, function () {
                        $newNextElement.css('left', '100%');
                        $newPrevElement.css('left', '-100%');
                    });
                } else {
                    let $activeElement = $(currentElement).find('.active');
                    let $targetElement;
                    if (slideDirection === 'prev') {
                        $targetElement = $activeElement.siblings('.prev');
                    } else {
                        $targetElement = $activeElement.siblings('.next');
                    }

                    $activeElement.removeClass('active');
                    $activeElement.siblings('.next').removeClass('next');
                    $activeElement.siblings('.prev').removeClass('prev');

                    $targetElement.addClass('active');

                    let $newPrevElement, $newNextElement;
                    $newPrevElement = $targetElement.prev();
                    if ($newPrevElement.length === 0) {
                        $newPrevElement = $targetElement.siblings().last();
                    }
                    $newPrevElement.addClass('prev');

                    $newNextElement = $targetElement.next();
                    if ($newNextElement.length === 0) {
                        $newNextElement = $targetElement.siblings().first();
                    }
                    $newNextElement.addClass('next');
                }
            });
            self.updateNextAndPrevButtons($sliderContainer);
        }
    };
});